import { createCommand } from 'lexical'

export const INSERT_SELECT = createCommand()
export const INSERT_INPUT = createCommand()
